import { I18n } from "@assets/strings";
import { Range } from "immutable";
import React from "react";
import styled from "styled-components";
import defaultBanner from "@assets/images/variant-jaangal/defaults/banner-4.jpg";
import { Group } from "@domain/group/group";
import { ImageVersions } from "@domain/media/dtos";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { CategoryLabel } from "@ui/components/categoryLabel";
import { Clamp } from "@ui/components/containers/clamp";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Row, Stack, stack } from "@ui/components/layout";
import { desktop, gap, mobile } from "@ui/styles/utils";
import { Star } from "@ui/pages/lms/coursePage/feedback/star";
import { GroupMenu } from "./groupMenu";
import { SubscriberInfos } from "./subscriberInfos";
interface ShareroomHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const ShareroomHeader: React.FC<ShareroomHeaderProps> = ({ shareroom, ...htmlProps }) => {
	const {
		banner,
		name,
		description,
		categories,
		feedbacks: { count, meanScore },
	} = shareroom;

	//TODO refactoring this component.
	return (
		<Container {...htmlProps}>
			<StyledBackgroundImage
				image={banner}
				defaultUrl={!banner ? defaultBanner : undefined}
				size={ImageVersions.MEDIUM}
				backdrop
				fullGradient
			/>
			<ShareroomInfos>
				<BlocStack>
					<Title size={2}>{name}</Title>
					<Description size={2}>{description}</Description>
				</BlocStack>
				<Bloc>
					<ScoreAndAvis>
						{meanScore ? (
							<Score>
								<MeanScore>{meanScore.toFixed(1)}</MeanScore>
								{Range(1, 6).map((n) => (
									<Star key={n} $isFilled={meanScore >= n} />
								))}
							</Score>
						) : null}
						{count ? <FeedbackCount>{I18n.t("shareroom.review.title", { count: count })}</FeedbackCount> : null}
					</ScoreAndAvis>
					{shareroom.license === "PREMIUM" && <SubscriberInfos shareroom={shareroom} />}
				</Bloc>
			</ShareroomInfos>
			<StyledMenu group={shareroom} />
			{categories[0] && categories[0] !== "OTHERS" && <Category category={categories[0]} />}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	position: relative;
`;

const StyledBackgroundImage = styled(BackgroundImage)`
	height: 340px;

	@media ${mobile} {
		height: 290px;
	}
	> :nth-child(2) {
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0.7) 100%, rgba(0, 0, 0, 0));
	}
	> div {
		border-radius: 13px;
	}
`;

const ShareroomInfos = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 60px 40px;
	@media ${mobile} {
		padding: 20px;
	}
	${stack(20)};
	@media ${desktop} {
		width: 100%;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;

const Title = styled(Clamp)`
	${({ theme }) => theme.textStyles.subtitle}
	color:#fff;
	font-size: 1.875rem;
	@media ${mobile} {
		font-size: 1.2rem;
		margin-top: 60px;
	}
`;

const Description = styled(Clamp)`
	font-weight: 500;
	color: #fff;
	@media ${mobile} {
		font-size: 13px;
	}
`;

const StyledMenu = styled(GroupMenu)`
	position: absolute;
	right: 15px;
	top: 22px;
	@media ${mobile} {
		right: 12px;
	}
	background: #fff;
`;

const Category = styled(CategoryLabel)`
	display: inline-block;
	position: absolute;
	top: 22px;
	max-width: 65%;
	right: 60px;
`;
const Score = styled.div`
	display: flex;
	align-items: center;
	${gap(4, "row")}
	svg {
		width: 14px;
	}
	@media (max-width: 900px) {
		align-self: flex-start;
		font-size: 16px;
		svg {
			width: 14px;
		}
	}
`;
const MeanScore = styled.div`
	color: ${({ theme }) => theme.colors.white};
	font-size: 16px;
`;
const ScoreAndAvis = styled.div`
	margin-top: 5px;
	display: flex;
	${gap(25, "row")}
	align-items: center;
	color: ${({ theme }) => theme.colors.white};
	@media (max-width: 900px) {
		flex-direction: row;
		align-items: center;
		font-size: 12px;
	}
	@media ${mobile} {
		position: absolute;
		bottom: 50px;
	}
`;
const FeedbackCount = styled.div`
	font-size: 14px;
`;
const Bloc = styled(Row)`
	@media ${mobile} {
		position: absolute;
		bottom: 40px;
		display: flex;
		flex-direction: column;
		${stack(10)}
	}
`;
const BlocStack = styled(Stack)`
	${gap(20)}
	width: 50%;
	@media ${mobile} {
		position: absolute;
		top: 5px;
		${gap(10)}
		width: 100%;
	}
`;
